var $b18f563206bd731d$exports = {};
$b18f563206bd731d$exports = {
    "help": `Ajutor`,
    "info": `Informa\u{163}ii`
};


export {$b18f563206bd731d$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
